<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col></b-col>
        <b-col md="6">
          <b-card variant="light" class="p-1 logwrap">
            <h4 v-html="signedupmsg"></h4>

            <div class="text-center">
              <b-button-group size="lg">
                <b-button variant="primary" class="up-btn active-premium">{{
                  details.category
                }}</b-button>
              </b-button-group>
            </div>
            <div>
              <div class="welc">
                <p class="payment-headtitle text-center">
                  Making Payment For {{ details.category }} Plans
                </p>
                <div
                  v-if="discountSeason == 'true' || discountSeason == true"
                  class="percent-off w-8 h-8 bg-red"
                >
                  {{ discountPercentage }}% Off
                </div>
                <b-button-group size="lg">
                  <b-button
                    v-for="(type, index) in premiumplans
                      .map(x => x.type)
                      .filter((item, i, array) => array.indexOf(item) === i)"
                    :key="index"
                    variant="primary"
                    @click="changePlan(type)"
                    class="up-btn"
                    :class="
                      currentplan == type
                        ? 'active-premium'
                        : 'inactive-premium'
                    "
                    >{{ type }}</b-button
                  >
                  <!-- <b-button variant="primary" v-if="details.category == 'Organization'" @click="changePlan('Credit'}})" class="up-btn" :class="currentplan == 'Credit' ? 'active-premium' : 'inactive-premium'">Credit(PAYG)</b-button> -->
                </b-button-group>
              </div>

              <form @submit.prevent="">
                <b-row>
                  <b-col xs="6">
                    <p class="upgrade-details">Voucher Code :</p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">{{ payload.trxcode }}</p>
                  </b-col>
                </b-row>

                <b-row v-if="details.category == 'Organization'">
                  <b-col xs="6">
                    <p class="upgrade-details">Plan Variant:</p>

                    <p v-for="existing, index in existingpremiums" :key="index" style="color:red; font-size:12px">
                      You still have a Premium plan in <b>{{ existing.premium_type }} {{ existing.premium_variant }}</b>.
                      <span v-if="existing.premium_type == 'PAYG'">Subscribing to a PAYG Plan will override an existing Monthly or Yearly Plan</span>
                      <span v-if="existing.premium_type != 'PAYG'">Subscribing to a higher Monthly or Yearly plan will override the existing Monthly or Yearly Plan</span>
                    </p>
                  </b-col>

                  <b-col xs="6">
                    <b-form-group
                      class="nested-form-group"
                      label="Select Plan Variant:"
                      label-for="category"
                    >
                      <b-form-select
                        v-model="payload.plan_id"
                        @change="getVariantDetails"
                        :options="premiumvariant"
                      >
                        <b-form-select-option value="null"
                          >--Select Variant--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <div v-if="Object.keys(currentPlanObj).length > 0" class="reduction-explain ml-1 mt-n2">
                      <div v-for="(item, index) in getPlanItems" :key="index">
                        <div class="tooltip-wrapper">
                          <b-icon-check2 color="green" class="mt-2"></b-icon-check2>
                          <p class="">{{ item.text }}</p>
                          <b-icon-info-circle-fill
                            :id="`tooltip-items-1${index}`"
                            class="mt-2 cursor-pointer"
                          ></b-icon-info-circle-fill>
                          <b-tooltip
                            :target="`tooltip-items-1${index}`"
                            custom-class="tooltip"
                            style="width: 500px"
                            triggers="hover"
                          >
                            <span class="info-span">{{ item.tooltip }}</span>
                          </b-tooltip>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="mt-3" v-if="details.category == 'Individual'">
                  <b-col xs="6">
                    <p class="upgrade-details">Plan Type:</p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">{{ ptype }}</p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col xs="6">
                    <p class="upgrade-details">Plan Price</p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">
                      N{{ $formatAmount(originalAmount) }}
                    </p>
                  </b-col>
                </b-row>

                <b-row v-if="currentplan != 'Credit'">
                  <b-col xs="6">
                    <p class="upgrade-details">
                      Plan Duration({{ currentplan }}):
                    </p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">
                      <b-form-group label="" label-for="tottime">
                        <b-form-spinbutton
                          id="duration"
                          :disabled="couponObject.coupon_type == 'extended'"
                          v-model="payload.premduration"
                          min="1"
                          max="12"
                          step="1"
                        ></b-form-spinbutton>
                      </b-form-group>
                    </p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col xs="6">
                    <p class="upgrade-details">
                      {{ details.category }}'s Name :
                    </p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">{{ payload.name }}</p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col xs="6">
                    <p class="upgrade-details">
                      {{ details.category }}'s Email :
                    </p>
                  </b-col>

                  <b-col xs="6">
                    <p class="upgrade-details-value">{{ payload.email }}</p>
                  </b-col>
                </b-row>

                <div v-if="details.category == 'Individual'">
                  <b-row>
                    <b-col xs="6">
                      <p class="upgrade-details">Exam Category :</p>
                    </b-col>

                    <b-col xs="6">
                      <p class="upgrade-details-value">
                        {{ payload.category }}
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xs="12">
                      <b-overlay
                        :show="chkcatarr"
                        rounded
                        opacity="0.6"
                        spinner-type="grow"
                        spinner-small
                        spinner-variant="primary"
                        class="w-100"
                      >
                        <b-form-group
                          class="nested-form-group"
                          label="Select Exam Category :"
                          label-for="category"
                        >
                          <b-form-select
                            v-model="payload.category"
                            :options="categoriesArray"
                            @change="categoryChanged"
                            value-field="name"
                            text-field="name"
                          >
                            <b-form-select-option value="null"
                              >--Select category--</b-form-select-option
                            >
                          </b-form-select>
                        </b-form-group>
                      </b-overlay>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col xs="6">
                      <p class="upgrade-details">institution :</p>
                    </b-col>

                    <b-col xs="6">
                      <p class="upgrade-details-value">
                        {{ payload.institution }}
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xs="12">
                      <b-form-group
                        v-if="this.sameName != 'Yes'"
                        class="nested-form-group"
                        label="Select Institution"
                        label-for="institution"
                      >
                        <!-- <p>Select JAMB as Institution</p> -->
                        <b-overlay
                          :show="payload.category == null"
                          rounded
                          opacity="0.6"
                          spinner-type="grow"
                          spinner-small
                          spinner-variant="primary"
                          class="w-100"
                        >
                          <b-form-select
                            v-model="payload.institution_id"
                            @change="institutionChanged"
                            :options="institutionsArray"
                            value-field="track_id"
                            text-field="name"
                          >
                            <b-form-select-option value="null"
                              >--Select Institution--</b-form-select-option
                            >
                          </b-form-select>
                        </b-overlay>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row
                    v-if="
                      structure == 'Section' && payload.institution != null
                    "
                  >
                    <b-col xs="12">
                      <b-form-group
                        class="nested-form-group"
                        label="Select Level"
                        label-for="institution"
                      >
                        <b-form-select
                          v-model="payload.level"
                          @change="levelChanged"
                          :options="levelsArray"
                        >
                          <b-form-select-option value="null"
                            >--Select Level--</b-form-select-option
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row
                    v-if="
                      structure == 'Subject' && payload.institution != null
                    "
                  >
                    <b-col xs="6">
                      <p class="upgrade-details">Subjects available :</p>
                    </b-col>

                    <b-col xs="6">
                      <p class="upgrade-details-value">
                        {{ subjectsArray.join(" , ") }}
                      </p>
                    </b-col>
                  </b-row>
                  <b-row
                    v-if="structure == 'Section' && payload.level != null"
                  >
                    <b-col xs="6">
                      <p class="upgrade-details">Courses available :</p>
                    </b-col>

                    <b-col xs="6">
                      <p class="upgrade-details-value">
                        {{ coursesArray.map(x => x.value).join(", ") }}
                      </p>
                    </b-col>
                  </b-row>
                </div>

                <b-row class="mt-3">
                  <b-col xs="6">
                    <p class="upgrade-details">Coupon Code (If Any) :</p>

                    <div v-if="couponStatus">
                      <div class="coupon-details">
                        <img
                          :src="couponObject.coupon_sponsor_logo"
                          class="sponsor-logo"
                        />
                        <p :style="{ 'font-size': '14px', color: 'green' }">
                          This coupon is sponsored by
                          <b>{{ couponObject.coupon_sponsor }}</b>
                        </p>
                      </div>

                      <p :style="{ 'font-size': '13px', color: 'green' }">
                        {{ couponObject.coupon_description }}
                      </p>
                    </div>
                  </b-col>

                  <b-col xs="6">
                    <b-form-group label="">
                      <b-form-input
                        v-model="payload.couponcode"
                        placeholder="Coupon Code(Optional)"
                      ></b-form-input>
                    </b-form-group>
                    <p
                      v-if="couponMessage.length > 0"
                      :style="{ color: couponStatus ? 'green' : 'red' }"
                    >
                      {{ couponMessage }}
                    </p>
                    <b-overlay
                      :show="applyingCoupon"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class="w-100"
                    >
                      <b-button
                        :disabled="payload.couponcode.length == 0"
                        @click="applyCoupon"
                        class="btn-md p-1 w-100"
                        variant="secondary"
                      >
                        Apply
                      </b-button>
                    </b-overlay>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col xs="6">
                    <p class="upgrade-details">Amount to be Paid :</p>
                  </b-col>

                  <b-col xs="6">
                    <div class="amount-value upgrade-details-value">
                      <p class="initial-amount" v-if="amountReduction">
                        N{{ $formatAmount(originalAmount) }}
                      </p>
                      <p class="new-amount" v-if="amountReduction">
                        N{{ pamount > 0 ? $formatAmount(pamount) : pamount }}
                      </p>
                      <p v-if="!amountReduction" class="new-amount">
                        N{{ pamount > 0 ? $formatAmount(pamount) : pamount }}
                      </p>
                    </div>
                    <ul v-if="amountReduction" class="reduction-explain">
                      <li
                        v-for="(explain, index) in reductionExplanation"
                        :key="index"
                      >
                        {{ explain }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col xs="12" class="mb-2 small-text">
                    <b-form-checkbox v-model="agree" value="true"
                      >I Agree to Quicktest's
                      <a href="https://usequicktest.com/tos" target="_blank"
                        >Terms of Use</a
                      >
                      and
                      <a href="https://usequicktest.com/privacy" target="_blank"
                        >Privacy Policy</a
                      ></b-form-checkbox
                    >
                  </b-col>

                  <b-col xs="12" class="mb-2 small-text">
                    <b-form-checkbox v-model="payload.savecard" value="true"
                      ><b>Auto Renew </b> ({{
                        this.details.category == "Organization"
                          ? "Don't stop administering Tests"
                          : "Don't stop practicing"
                      }}, We'll help you renew when its time). You can stop it
                      anytime on your Dashboard.</b-form-checkbox
                    >
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="3"> </b-col>
                  <b-col md="6" v-if="pamount > 0">
                    <b-overlay
                      :show="upgrading"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class="w-100"
                    >
                      <paystack
                        :amount="pamount * 100"
                        :email="this.details.email"
                        :paystackkey="paystackkey"
                        :reference="payload.trxcode"
                        :callback="confirmPayment"
                        :close="closePayment"
                        :embed="false"
                        class="paystack_wrapper"
                      >
                        <b-button
                          :disabled="chkfields"
                          @click="triggerPaystack"
                          type="submit"
                          class="btn-md p-1 w-100"
                          variant="success"
                        >
                          Upgrade
                        </b-button>
                      </paystack>
                    </b-overlay>

                    <b-button
                      v-if="upgrading"
                      class="w-100 p-2 mt-3 btntxt"
                      variant="dark"
                      @click="stopproceed"
                    >
                      Cancel
                    </b-button>
                  </b-col>

                  <b-col md="6" v-if="pamount == 0">
                    <b-overlay
                      :show="upgrading"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class="w-100"
                    >
                      <b-button
                        :disabled="chkfields"
                        @click="triggerPaystack"
                        type="submit"
                        class="btn-md p-1 w-100"
                        variant="success"
                      >
                        Upgrade
                      </b-button>
                    </b-overlay>

                    <b-button
                      v-if="upgrading"
                      class="w-100 p-2 mt-3 btntxt"
                      variant="dark"
                      @click="stopproceed"
                    >
                      Cancel
                    </b-button>
                  </b-col>
                  <b-col md="3"></b-col>
                </b-row>
              </form>
            </div>
          </b-card>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import store from "@/store";
import { mapState, mapActions } from "vuex";
import paystack from "vue-paystack";
import refreshLogin from "@/mixings/refreshLogin";

export default {
  components: {
    paystack
  },
  data() {
    return {
      payload: this.upgradeObject(),
      countdown: 5,
      upgrading: false,
      frompath: "",
      emailexist: true,
      emsg: "",
      cpword: "",
      phoneerr: "",
      erronphone: true,
      erronpword: true,
      pworderr: "",
      signedupmsg: "",
      pamount: null,
      ptype: "",
      categoriesArray: [],
      variantArray: [],
      institutionsArray: [],
      subjectsArray: [],
      levelsArray: [],
      coursesArray: [],
      agree: false,
      currentplan: "Monthly",
      currentPlanObj: {},
      org: "Quicktest",
      orgsn: "QKT",
      sameName: "",
      structure: "",
      refdiscount: "",
      refamount: this.pamount,
      campdiscount: 0.45,
      paystackkey: "pk_live_f9ffdd3f8afa2c352368d4a8c95a5af0a4b9d985", // "pk_test_1e4df0a4a0fb63c0cc4695a69d5735ce6f489ad2",
      discountSeason: false,
      discountPercentage: 0,
      applyingCoupon: false,
      couponMessage: "",
      couponObject: {},
      couponStatus: false,
      originalAmount: 0,
      premiumplans: [],
      amountReduction: false,
      reductionExplanation: [],
      premiumvariant: [],
      currentPlan: {},
      query: ""
    };
  },

  beforeRouteEnter(to, from, next) {
    // Fetch the Categories and Institutions available for upgrade before entering the Page to avoid lagging user
    return store.dispatch("exam/retrieveCategories").then(() => {
      return store.dispatch("exam/retrieveInstitutions").then(() => {
        next();
      });
    });
  },
  mixings: [refreshLogin],
  watch: {
    "payload.premduration"(val) {

      this.couponStatus = false;
      this.couponMessage = "";
      this.couponObject = {};
      this.amountReduction = false
      this.reductionExplanation = []

      this.payload.amount = val * this.originalAmount;
      this.pamount = this.payload.amount

      this.getDiscount();
    },
    pamount(val) {
      this.payload.amount = val;
    }
  },

  updated() {
    // this.currentplan = this.$route.query.plan
    // When User chnges the Upgrade Plan, it effects in the Query, this will grab the new Upgrade type from the Query on Update
  },

  async mounted() {
    this.discountSeason = false;
    this.discountPercentage = 0;

    if (this.loggedin) {
      if (this.$route.query.bypass == "goland") {
        // Do Nothing
      } else {
        // this.goLand();
      }
    } else {
      let remember = this.getCookie("remember");

      if (remember == 1) {
        let sqid = this.getCookie("qid");
        let details = {
          qid: sqid,
          page: "landing"
        };

        return await this.sendLogin(details).then(() => {
          this.goLand();
          store.dispatch("exam/retrieveCategories").then(() => {
            store.dispatch("exam/retrieveInstitutions").then(() => {});
          });
        });
      } else {
        this.$router.push({
          name: "login",
          query: { redirect: this.$route.fullPath }
        });
      }
    }

    this.payload.user_category = this.details.category;

    if (this.Categories.length > 0) {
      // If the category Array has been populated by the response from the Api
      let typesarr = this.Categories //.map(x => ({ text: x.name, value : x.name })); // Get the Categories and map their names to the 'typesarray'
      this.categoriesArray = typesarr; // set the value of the data property 'Categoriesarray' to this value
    } else {
      // If the initial API call did not send back the response on time, dispatch another request and this time wait for the request to send a response before doing any further operation
      store.dispatch("exam/retrieveCategories").then(() => {
        store.dispatch("exam/retrieveInstitutions");

        let typesarr = this.Categories //.map(x => ({ text: x.name, value : x.name })); // Get the Categories and map their names to the 'typesarray'
        this.categoriesArray = typesarr; // set the value of the data property 'Categoriesarray' to this value
      });
    }

    await this.fetchPremiumplans();

    await this.getPlans();
  },

  methods: {
    ...mapActions("exam", [
      "setSelect",
      "retrieveInstitutions",
      "retrieveRefdiscount",
      "applyCouponDiscount"
    ]),
    ...mapActions("dashboard", ["fetchPremiumplans"]),
    ...mapActions("exam", ["retrieveCategories"]),
    ...mapActions("loginmaster", [
      "setErr",
      "chkemail",
      "getVoucher",
      "userUpgrade",
      "getPremiumPlans"
    ]),

    upgradeObject() {
      // The Upgrade Object returned to the 'Upgrade' Data Property
      return {
        email: "",
        organization: "",
        organizationsn: "",
        organization_id: "",
        name: "",
        amount: 0,
        trxcode: "",
        premtype: "",
        premduration: 1,
        user_category: "",
        category: null,
        institution: null,
        institution_id: null,
        level: null,
        origin: "",
        environ: "",
        partnershipcode: "",
        couponcode: "",
        premiumvariant: [],
        savecard: true
      };
    },
    async fetchInstitutionsData() {
      this.loading2 = true;
      this.query = `?category=${this.payload.category}&orgId=${this.details.quicktest_details.track_id}`;

      try {
        const response = await this.retrieveInstitutions(this.query);

        this.institutionsArray = response?.data;
        this.meta = response?.meta;

        // this.poolPremiumInstitutions();

        this.loading2 = false;
      } catch {
        this.loading2 = false;
      }
    },

    async getPlans() {
      try {
        const response = await this.getPremiumPlans();

        this.premiumplans = response.data.filter(
          x => x.category == this.details.category
        );

        this.changePlan("Monthly");
        this.setDetails();
      } catch (err) {
        console.log(err);
      }
    },

    async setDetails() {
      await this.getVoucher().then(response => {
        this.payload.trxcode = response.voucher;
        this.payload.email = this.details.email;
        this.payload.name =
          this.details.category == "Individual"
            ? this.details.fullname
            : this.details.org_details.organization_name;
        this.payload.premtype = this.currentplan;
        if (this.details.category == "Organization") {
          this.payload.organization = this.details.org_details.organization_name;
          this.payload.organization_id = this.details.org_details.track_id;
          this.payload.organizationsn = this.details.org_details.organization_shortname;
        }

        this.payload.premduration = 1;

        // this.setPlanConfigByCategory()
      });
    },

    async applyCoupon() {
      const payload = {
        code: this.payload.couponcode,
        amount: this.pamount
      };

      this.applyingCoupon = true;

      return this.applyCouponDiscount(payload).then(response => {
        this.couponStatus = response.status;
        this.couponMessage = response.message;
        this.couponObject = response.data;
        // this.pamount = response.data.newamount;

        if (response.status) {
          this.reductionExplanation.push(
            `${this.couponObject.coupon_discount}% Off From Coupon`
          );
          this.pamount = this.amountReducer(
            this.pamount,
            this.couponObject.coupon_discount
          );

          if (this.couponObject.coupon_type == "extended") {
            this.ptype = this.couponObject.coupon_plan;
            this.payload.premtype = this.couponObject.coupon_plan;
          }
        }

        this.applyingCoupon = false;
      });
    },

    getVariantDetails(variantId) {
      const selected = this.premiumplans.find(x => x.track_id == variantId);

      this.currentPlanObj = selected;

      this.pamount = JSON.parse(selected.variant_amounts)["naira"].value;
      this.payload.plan_id = selected.track_id;
      this.originalAmount = JSON.parse(selected.variant_amounts)["naira"].value;
      this.ptype = selected.variant;
      this.payload.premiumvariant = selected.variant;

      this.payload.amount = this.pamount;
    },

    setPlanConfigByCategory() {
      this.reductionExplanation = [];

      if (this.details.category == "Individual") {
        const selected = this.premiumplans.find(
          x => x.type == this.currentplan && x.category == this.details.category
        );

        this.currentPlanObj = selected;

        this.pamount = JSON.parse(selected.variant_amounts)["naira"].value;
        this.payload.plan_id = selected.track_id;
        this.originalAmount = JSON.parse(selected.variant_amounts)[
          "naira"
        ].value;
        this.ptype = selected.variant;
        this.payload.premiumvariant = selected.variant;

        this.payload.amount = this.pamount;
      } else if (this.details.category == "Organization") {
        const selected = this.premiumplans.filter(
          x => x.type == this.currentplan && x.category == this.details.category
        );

        this.premiumvariant = selected.map(x => ({
          text: x.variant,
          value: x.track_id,
          disabled : this.existingpremiums.find(y => y.premium_variant == x.variant && x.type == this.currentplan && this.currentplan != 'PAYG') || (this.existingpremiums.find(y => x.variant_level < y.premium_variant_level  && y.premium_type == this.currentplan))  ? true : false
        }));

        this.pamount = 0;
        this.payload.plan_id = null;
        this.originalAmount = 0;
      }

      this.activateDiscountSeason(
        this.details.discount_details.discount_season,
        Number(this.details.discount_details.discount_percentage)
      );
    },
    changePlan(plan) {
      this.currentplan = plan;
      this.payload.premtype = this.currentplan;
      this.couponStatus = false;
      this.couponMessage = "";
      this.couponObject = {};
      this.currentPlanObj = {};
      this.payload.premduration = 1;
      this.reductionExplanation = []
      this.amountReduction = false
      // this.originalA;

      this.setPlanConfigByCategory();
      this.getDiscount();
    },

    getDiscount() {
      return this.retrieveRefdiscount(this.details.email).then(response => {
        this.refdiscount = response;

        if (response > 1) {
          this.reductionExplanation.push(
            `${response}% Off From Referrals Discount`
          );

          if(response < 100){
            this.pamount = this.amountReducer(this.pamount, response);
          }else{
            this.pamount = 0
          }
          
        }
      });
    },

    activateDiscountSeason(discountSeason, discountPercentage) {
      this.discountSeason = discountSeason;
      this.discountPercentage = discountPercentage;

      if (this.discountSeason == "true" || this.discountSeason == true) {
        this.reductionExplanation.push(
          `${this.discountPercentage}% Off From Discount Season`
        );
        this.pamount = this.amountReducer(
          this.pamount,
          this.discountPercentage
        );
      }
    },

    amountReducer(current, percent) {
      this.amountReduction = true;
      return current - ((percent / 100) * current);
    },
    setloader() {
      // Initiates the rolling process until the User is redirected to the Payment Gateway
      this.upgrading = true;
    },
    // Cancels the Upgrade Process when its taking too much time and the request has broken.
    stopproceed() {
      // Stops the upgrade and enables the Upgrade button back again
      this.upgrading = false;
      // Calls the setDetails Method to reset the Voucher
      this.setDetails();
    },

    async upgradeUser() {
      // Start Loader to give user the right impression that the Operation is currently being processed
      this.setloader();
      console.log("User is Upgrading");
      this.payload.user_category = this.details.category;
      this.payload.environ = this.environ;
      this.payload.origin = this.origin;

      // Dispatch the UserUpgrade Action in the Store and send the Upgrade details object as an Argument
      // Returns the Payment Gateway URL
      try {
        return await this.userUpgrade(this.payload)
        .then(() => {
          this.upgrading = false;
          // console.log(response)
          // this.setDetails()
          // window.location = response.rurl; // Passing the Paymennt Gateway to the windows.location for redirection
        })
        .catch(err => {
          this.setDetails()
          this.$bvModal.msgBoxOk(
            "Check your Network Connection. An Error Occured. " +
              err?.response?.data?.message,
            {
              title: "No Network Connection",
              size: "xs",
              centered: true
            }
          );
        });  
      } catch (error) {
        this.setDetails()
      }
      
    },

    async triggerPaystack() {
      this.upgrading = true;
      await this.upgradeUser()
        .then(() => {
          if (this.pamount == 0) {
            this.$router.push({
              name: "verify",
              query: { reference: this.payload.trxcode }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closePayment() {
      this.upgrading = false;
      this.setDetails();
    },
    confirmPayment() {
      // this.upgradeUser();
      this.upgrading = false;

      this.$router.push({
        name: "verify",
        query: {
          reference: this.payload.trxcode,
          redirect: this.$route.query.redirect
        }
      });
    }
  },

  computed: {
    // The Chkcatarr Property returns true if the category Array is empty so as to trigger Show an overlay over the select field of the category
    getPlanItems() {
      return this?.currentPlanObj?.variant_items
        ? JSON.parse(this?.currentPlanObj?.variant_items)
        : {};
    },
    chkcatarr() {
      if (this.categoriesArray.length < 1) {
        return true;
      } else {
        return false;
      }
    },
    // Chkfields checks if the required Fields for submission are empty. It returns true if anyone of them is empty and disables the Upgrade button.
    // Otherwise it returns false if all the required fields has been filled
    chkfields() {
      if (this.details.category == "Individual") {
        if (
          this.payload.name.length <= 0 ||
          this.payload.email.length <= 0 ||
          this.payload.amount < 0 ||
          this.payload.premtype.length <= 0 ||
          this.payload.category == null ||
          this.payload.institution == null ||
          (this.structure == "Section" && this.payload.level == null) ||
          this.agree == false
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.details.category == "Organization") {
        if (
          this.payload.name.length <= 0 ||
          this.payload.email.length <= 0 ||
          this.payload.premtype.length <= 0 ||
          this.payload.premiumvariant == null ||
          this.agree == false
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      start_config: state => state.exam.start_config,
      plan: state => state.loginmaster.details.plan,
      trial: state => state.loginmaster.trial,
      premium: state => state.loginmaster.details.premium_details,
      started: state => state.exam.started,
      allinsti: state => state.exam.allinstitutions,
      Categories: state => state.exam.allcategories,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin,
      existingpremiums: state => state.dashboard.premiumplans
    })
  }
};
</script>

<style scoped>
.logwrap {
  box-shadow: 5px 5px 15px grey;
}

.welc {
  font-size: 1.3rem;
  display: flex;
  flex-direction: column;
  justify-items: center;
  gap: 10px;
  align-items: center;
}

.amount-value {
  font-size: 1.3rem;
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  gap: 10px;
}

.reduction-explain {
  margin-left: -20px;
}
p {
  text-align: left;
  font-size: 16px;
  padding: 5px;
}

.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.loginput {
  width: 300px;
  padding: 10px;
}

.btn-md {
  font-size: 18px;
  font-weight: bold;
  background-color: #00984a;
  color: white;
  cursor: pointer;
  border: 0px;
}

.logimg {
  width: 100%;
  height: 60vh;
}

.flabel {
  font-size: 1.2rem;
  font-weight: bold;
}

.upgrade-details {
  font-size: 1.2rem;
  font-weight: bold;
}

.upgrade-details-value {
  font-size: 1.2rem;
}

.active-premium {
  background-color: rgb(8, 8, 238);
}

.inactive-premium {
  background-color: rgba(128, 128, 136, 0.74);
}

.up-btn {
  border: 0px;
}

.payment-headtitle {
  font-size: 1.5rem;
}
.small-text {
  font-size: 0.8rem;
}
.original {
  text-decoration: line-through;
  color: gray;
}

.sponsor-logo {
  width: 80px;
  height: 80px;
}

.coupon-details {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.percent-off {
  padding: 5px;
  display: flex;
  flex-direction: row;
  background-color: red;
  color: white;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px 5px;
}
.initial-amount {
  text-decoration: line-through;
  color: gray;
  font-size: 18px;
  margin-top: 2px;
}

.new-amount {
  font-size: 20px;
}

.paystack_wrapper {
  width: 100%;
  padding: 0px;
  border: 0px solid black;
}

.tooltip {
  width: 700px;
}

.tooltip-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
}

.info-span {
  display: block;
  text-align: left;
  color: white;
}

@media screen and (max-width: 999px) {
  .upgrade-details {
    font-size: 0.85rem;
  }
  .upgrade-details-value {
    font-size: 0.85rem;
  }
  .payment-headtitle {
    font-size: 1.2rem;
  }
}
</style>
